import { useEffect, useState, createRef } from 'react';
import DeviceScreen from 'lib/DeviceScreen';

export default function useExpanded(topRef = createRef()) {
  const [expanded, setExpanded] = useState(true);

  const toggleExpanded = () => {
    const newExpanded = !expanded;
    const headerRefTop = topRef.current.offsetTop;

    if (!newExpanded) {
      window.scrollTo(0, headerRefTop);
    }

    setExpanded(newExpanded);
  };

  const isExtraSmall = DeviceScreen.isExtraSmall();

  useEffect(() => {
    if (DeviceScreen.isExtraSmall()) {
      setExpanded(false);
    }
  }, [isExtraSmall]);

  return [expanded, topRef, toggleExpanded];
}
